import GenericDropdown from '../GenericDropdown';
import GenericPills from '../GenericPills/GenericPills';

import useStyles from './styles';
import { IGenericPillsDropdownProps } from './types';

function GenericPillsDropdown(props: IGenericPillsDropdownProps) {
  const { name, pillsDefaultValue, dropdownValues } = { ...props };

  const classes = useStyles();

  const pillsValues = dropdownValues.map((v) => ({ text: v.title, value: v.value }));
  return (
    <>
      <div className={classes.pills}>
        <GenericPills
          pills={pillsValues}
          name={name}
          defaultValue={pillsDefaultValue}
          formProps={props.formProps}
        />
      </div>
      <div className={classes.dropdown}>
        <GenericDropdown {...props} />
      </div>
    </>
  );
}
export default GenericPillsDropdown;
